import.meta.glob(['../images/**', '../fonts/**']);
import.meta.glob(['./../../blocks/src/**/block.css'], { eager: true });
import.meta.glob(['./../../blocks/src/**/block.js'], { eager: true });

import { setIdForAllSwipers } from '@scripts/swiperfunctions';
console.log('Swiper IDs set for all swipers');
setIdForAllSwipers();
import '@scripts/menu';
import '@scripts/off-canvas';

// TODO : check if this is the correct place to import
import '@scripts/utilities/overlay';
import '@scripts/utilities/back-link';
import '@scripts/utilities/faq';
import '@scripts/utilities/post-toc';
import '@scripts/utilities/tooltip';
import '@scripts/utilities/hcp-product';
// Mapbox GL weighs ~1.5 MB – only fetch it on pages that actually render a map.
if (document.getElementById('mapbox')) {
    import('@scripts/custom-blocks/map');
}
